// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body[data-v-66a44124]{background-color:#eee}nav[data-v-66a44124]{background-color:#fff}a.navbar-brand[data-v-66a44124]{white-space:normal;text-align:center;word-break:break-all}html[data-v-66a44124]{font-size:14px}@media (min-width:768px){html[data-v-66a44124]{font-size:16px}}.box-shadow[data-v-66a44124]{box-shadow:0 .25rem .75rem rgba(0,0,0,.05)}", ""]);
// Exports
module.exports = exports;
